<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";

  let { fill = urbanColors.black } = $props();
</script>

<svg
  aria-hidden="true"
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    d="M16.385 15.9086C16.525 15.9086 16.63 15.96 16.735 16.0457C16.84 16.1314 16.875 16.2514 16.875 16.3886V17.52C16.875 17.6571 16.8225 17.76 16.735 17.8629C16.6475 17.9657 16.525 18 16.385 18H1.615C1.475 18 1.37 17.9486 1.265 17.8629C1.16 17.7771 1.125 17.6571 1.125 17.52V16.3886C1.125 16.2514 1.1775 16.1486 1.265 16.0457C1.3525 15.9429 1.475 15.9086 1.615 15.9086H16.385ZM15.44 8.04C15.5275 7.95429 15.5625 7.85143 15.5625 7.71429C15.5625 7.57714 15.51 7.45714 15.405 7.35429L14.6175 6.54857C14.5125 6.46286 14.39 6.42857 14.25 6.42857C14.11 6.42857 14.005 6.48 13.9175 6.58286L10.0675 10.4743V0.48C10.0675 0.342857 10.015 0.24 9.9275 0.137143C9.84 0.0342857 9.7175 0 9.5775 0H8.4225C8.2825 0 8.1775 0.0514286 8.0725 0.137143C7.9675 0.222857 7.9325 0.342857 7.9325 0.48V10.4914L4.0825 6.6C3.995 6.48 3.89 6.42857 3.75 6.42857C3.61 6.42857 3.4875 6.46286 3.3825 6.54857L2.56 7.35429C2.4725 7.45714 2.4375 7.57714 2.4375 7.71429C2.4375 7.85143 2.49 7.95429 2.595 8.04L8.6325 13.9886C8.7375 14.0914 8.86 14.1429 9 14.1429C9.14 14.1429 9.2625 14.0914 9.3675 13.9886L15.44 8.04Z"
    {fill}
  />
</svg>
